import React from "react";
import { useTranslation } from "react-i18next";
import Seo from "../seo/Seo";
import TodoText from "../components/TodoText";
import { Link } from "../i18n/LangContext";
import "../styles/Legal.css";

const ProcessorTable = ({ head, rows }) => (
  <div className="legal-table-wrap">
    <table className="legal-table">
      <thead>
        <tr>
          <th>{head.name}</th>
          <th>{head.purpose}</th>
          <th>{head.location}</th>
          <th>{head.link}</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((p, i) => (
          <tr key={i}>
            <td><strong>{p.name}</strong></td>
            <td>{p.purpose}</td>
            <td><TodoText>{p.location}</TodoText></td>
            <td>
              {p.url ? (
                <a href={p.url} target="_blank" rel="noopener noreferrer nofollow">
                  {new URL(p.url).hostname.replace(/^www\./, "")}
                </a>
              ) : (
                "—"
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const Privacy = () => {
  const { t } = useTranslation();
  const sections = t("privacy.sections", { returnObjects: true });
  const processors = t("privacy.processors", { returnObjects: true });
  const head = t("privacy.processorsHead", { returnObjects: true });

  return (
    <div className="legal-page">
      <Seo page="privacy" path="/privacy" />

      <section className="legal-hero">
        <div className="container">
          <h1>{t("privacy.title")}</h1>
          <p className="legal-lead">{t("privacy.lead")}</p>
        </div>
      </section>

      <section className="legal-body">
        <div className="container">

          <p className="legal-updated"><TodoText>{t("privacy.updated")}</TodoText></p>

          {sections.map((section, i) => (
            <div className="legal-section" key={i}>
              <h2>{section.title}</h2>

              {(section.body || []).map((para, j) => (
                <p key={j}><TodoText>{para}</TodoText></p>
              ))}

              {section.table && <ProcessorTable head={head} rows={processors} />}

              {section.items && (
                <ul className="legal-list">
                  {section.items.map((item, j) => (
                    <li key={j}>
                      <strong>{item.term}</strong> — <TodoText>{item.text}</TodoText>
                    </li>
                  ))}
                </ul>
              )}

              {(section.after || []).map((para, j) => (
                <p key={`a${j}`}><TodoText>{para}</TodoText></p>
              ))}
            </div>
          ))}

          <p className="legal-updated">
            <Link to="/company">{t("footer.company")}</Link>
          </p>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
